module.exports = __webpack_public_path__ + "static/media/btn_sheep_active.06079ca7.png";